import {
  DelistingReason,
  ListingReason,
  PromotionRecommendationReason,
} from 'common/api-types/recommendations';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

type Props = {
  reason: DelistingReason | PromotionRecommendationReason | ListingReason;
};

export const TranslatedReasons = ({ reason }: Props) => {
  const f = useFormatMessage();

  const reasons = {
    LOW_PPM: f('selection_recommendations.reasons:LOW_PPM'),
    HIGH_SHRINKAGE: f('selection_recommendations.reasons:HIGH_SHRINKAGE'),
    LOW_BASKET_PENETRATION: f('selection_recommendations.reasons:LOW_BASKET_PENETRATION'),
    NO_SALES: f('selection_recommendations.reasons:NO_SALES'),
    PROMO_OPPORTUNITY: f('selection_recommendations.reasons:PROMO_OPPORTUNITY'),
    MISSING: f('selection_recommendations.reasons:MISSING'),
    UNDERDEVELOPED: f('selection_recommendations.reasons:UNDERDEVELOPED'),
  };

  return reasons[reason];
};
